var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordPuzzles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Kelime Bulmaca",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F5A623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C97405"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wp-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08A0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-tile",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E7D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-hot",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F2A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#5C3300",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wp-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#5C3300",
    opacity: 0.38,
    filter: "url(#wp-bsh)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#9A5A03",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wp-face)",
    d: "M256.0,44.0 A46.3,46.3 0 0 1 337.1,60.1 A46.3,46.3 0 0 1 405.9,106.1 A46.3,46.3 0 0 1 451.9,174.9 A46.3,46.3 0 0 1 468.0,256.0 A46.3,46.3 0 0 1 451.9,337.1 A46.3,46.3 0 0 1 405.9,405.9 A46.3,46.3 0 0 1 337.1,451.9 A46.3,46.3 0 0 1 256.0,468.0 A46.3,46.3 0 0 1 174.9,451.9 A46.3,46.3 0 0 1 106.1,405.9 A46.3,46.3 0 0 1 60.1,337.1 A46.3,46.3 0 0 1 44.0,256.0 A46.3,46.3 0 0 1 60.1,174.9 A46.3,46.3 0 0 1 106.1,106.1 A46.3,46.3 0 0 1 174.9,60.1 A46.3,46.3 0 0 1 256.0,44.0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#A85D02",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#wp-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wp-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#wp-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#wp-osh)",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 34,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(197 135)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "O")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197 197)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "Y")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135 259)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "P")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197 259)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#8F1F1B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-hot)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#FFFFFF"
  }, "U")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259 259)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321 259)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "N")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197 321)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#B89458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    fill: "url(#wp-tile)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 40,
    fill: "#3A2A10"
  }, "N"))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(340 176) scale(20)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(150 196) scale(11)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordPuzzles);
export default __webpack_public_path__ + "static/media/word-puzzles.ff76a7b2f4c6c2d2b76e110d656e8f31.svg";
export { ForwardRef as ReactComponent };